var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapleLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.13,189.37V156.32m-28-103.49,28-16.65,28,16.66-8.53,50.45,23.88-20.47L176,96l-.68,28.25-37.09,19.27,11.13,12.06-82.13-.07L79.9,143.69,42.49,124.27,41.82,96l23.59-13.2L90.66,102.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapleLeaf);
export default __webpack_public_path__ + "static/media/MAPLE_LEAF.77086faaf2af4d2c2b42fa15c5ced2b7.svg";
export { ForwardRef as ReactComponent };